import React from "react";
import './AIInsideSystems.scss';

function AIInsideSystems() {

    return (
        <div className="AIInsideSystems modal-bg">
            <div className="content">
                <div className={'title'}>AI Inside Systems</div>
                <div className={'text'}>
                    <span>AI is not an add-on. It is engineered as part of the system architecture.</span>
                </div>
                <div className={'cards'}>
                    <div className={'cards__item'}>
                        <span>
                            AI integrated into operational workflows
                        </span>
                    </div>
                    <div className={'cards__item'}>
                        <span>
                            Clear boundaries between system logic and AI components
                        </span>
                    </div>
                    <div className={'cards__item'}>
                        <span>
                            Structured prompt architecture
                        </span>
                    </div>
                    <div className={'cards__item'}>
                        <span>
                            Monitoring, explainability and maintainability
                        </span>
                    </div>
                    <div className={'cards__item'}>
                        <span>
                            Human accountability over automated decisions
                        </span>
                    </div>
                </div>
                <div id={'system-lifecycle'}/>
            </div>
        </div>
    );
}

export default AIInsideSystems;